import { memo, useMemo } from "react";
import { Outlet } from "react-router-dom";
import { AutomationsApiContext } from "./automations-api";
import { useAutomationsRpcClient } from "./automations-rpc-client";
import { rpcAutomationsApi } from "./rpc-automations-api";

/** Puts the automations API in context for the automations v2 routes. */
export const AutomationsApiProvider = memo(function AutomationsApiProvider() {
  const client = useAutomationsRpcClient();
  const api = useMemo(
    () => (client ? rpcAutomationsApi(client) : undefined),
    [client],
  );
  if (!api) {
    return null;
  }
  return (
    <AutomationsApiContext.Provider value={api}>
      <Outlet />
    </AutomationsApiContext.Provider>
  );
});
